// extracted by mini-css-extract-plugin
module.exports = {"cls-1":"arrows_cls-1__SAAb2"};